/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../graphql/__generated__';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCountriesAndCurrenciesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetCountriesAndCurrenciesQuery = {
  readonly __typename?: 'Query';
  readonly countries?: {
    readonly __typename?: 'CountriesCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'EnumLabelOfCountry';
      readonly id: Types.Country;
      readonly region?: {
        readonly __typename?: 'EnumLabelOfRegion';
        readonly id: Types.Region;
      } | null;
    }> | null;
  } | null;
  readonly currencies?: {
    readonly __typename?: 'CurrenciesCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'EnumLabelOfCurrency';
      readonly id: Types.Currency;
      readonly displayName: string;
    }> | null;
  } | null;
};

export type GetOfferingCountryCodeQueryVariables = Types.Exact<{
  offeringId: Types.Scalars['UUID']['input'];
}>;

export type GetOfferingCountryCodeQuery = {
  readonly __typename?: 'Query';
  readonly publishedOfferings?: {
    readonly __typename?: 'PublishedOfferingsCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'OfferingFull';
      readonly id: string;
      readonly instruments: ReadonlyArray<{
        readonly __typename?: 'InstrumentFull';
        readonly id: string;
        readonly countryCode?: string | null;
      }>;
    }> | null;
  } | null;
};

export type IsInternalOffering_ManagerFullPartsFragment = {
  readonly __typename?: 'ManagerFull';
  readonly cmgEntityKey: string;
  readonly role: Types.ManagerRole;
};

export type IsInternalOffering_OfferingFullPartsFragment = {
  readonly __typename?: 'OfferingFull';
  readonly isInternal: boolean;
  readonly isAuthor: boolean;
  readonly syndicate?: {
    readonly __typename?: 'SyndicateFull';
    readonly managers: ReadonlyArray<{
      readonly __typename?: 'ManagerFull';
      readonly cmgEntityKey: string;
      readonly role: Types.ManagerRole;
    }>;
  } | null;
};

export type IsInternalOfferingQueryVariables = Types.Exact<{
  offeringId: Types.Scalars['UUID']['input'];
}>;

export type IsInternalOfferingQuery = {
  readonly __typename?: 'Query';
  readonly publishedOfferings?: {
    readonly __typename?: 'PublishedOfferingsCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'OfferingFull';
      readonly isInternal: boolean;
      readonly isAuthor: boolean;
      readonly syndicate?: {
        readonly __typename?: 'SyndicateFull';
        readonly managers: ReadonlyArray<{
          readonly __typename?: 'ManagerFull';
          readonly cmgEntityKey: string;
          readonly role: Types.ManagerRole;
        }>;
      } | null;
    }> | null;
  } | null;
};

export type IsOfferingAuthor_OfferingQueryVariables = Types.Exact<{
  offeringId: Types.Scalars['UUID']['input'];
}>;

export type IsOfferingAuthor_OfferingQuery = {
  readonly __typename?: 'Query';
  readonly privateOfferings?: {
    readonly __typename?: 'PrivateOfferingsCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'OfferingFull';
      readonly id: string;
      readonly isAuthor: boolean;
    }> | null;
  } | null;
  readonly publishedOfferings?: {
    readonly __typename?: 'PublishedOfferingsCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'OfferingFull';
      readonly id: string;
      readonly isAuthor: boolean;
    }> | null;
  } | null;
};

export const IsInternalOffering_ManagerFullPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IsInternalOffering_ManagerFullParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ManagerFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const IsInternalOffering_OfferingFullPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IsInternalOffering_OfferingFullParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OfferingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isInternal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isAuthor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'syndicate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'managers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'IsInternalOffering_ManagerFullParts' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IsInternalOffering_ManagerFullParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ManagerFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GetCountriesAndCurrenciesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCountriesAndCurrencies' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countries' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'take' },
                value: { kind: 'IntValue', value: '500' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'region' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currencies' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'take' },
                value: { kind: 'IntValue', value: '500' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetCountriesAndCurrenciesQuery__
 *
 * To run a query within a React component, call `useGetCountriesAndCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesAndCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesAndCurrenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountriesAndCurrenciesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCountriesAndCurrenciesQuery,
    GetCountriesAndCurrenciesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCountriesAndCurrenciesQuery, GetCountriesAndCurrenciesQueryVariables>(
    GetCountriesAndCurrenciesDocument,
    options
  );
}
export function useGetCountriesAndCurrenciesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCountriesAndCurrenciesQuery,
    GetCountriesAndCurrenciesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCountriesAndCurrenciesQuery,
    GetCountriesAndCurrenciesQueryVariables
  >(GetCountriesAndCurrenciesDocument, options);
}
// @ts-ignore
export function useGetCountriesAndCurrenciesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCountriesAndCurrenciesQuery,
    GetCountriesAndCurrenciesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetCountriesAndCurrenciesQuery,
  GetCountriesAndCurrenciesQueryVariables
>;
export function useGetCountriesAndCurrenciesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCountriesAndCurrenciesQuery,
        GetCountriesAndCurrenciesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetCountriesAndCurrenciesQuery | undefined,
  GetCountriesAndCurrenciesQueryVariables
>;
export function useGetCountriesAndCurrenciesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCountriesAndCurrenciesQuery,
        GetCountriesAndCurrenciesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCountriesAndCurrenciesQuery,
    GetCountriesAndCurrenciesQueryVariables
  >(GetCountriesAndCurrenciesDocument, options);
}
export type GetCountriesAndCurrenciesQueryHookResult = ReturnType<
  typeof useGetCountriesAndCurrenciesQuery
>;
export type GetCountriesAndCurrenciesLazyQueryHookResult = ReturnType<
  typeof useGetCountriesAndCurrenciesLazyQuery
>;
export type GetCountriesAndCurrenciesSuspenseQueryHookResult = ReturnType<
  typeof useGetCountriesAndCurrenciesSuspenseQuery
>;
export type GetCountriesAndCurrenciesQueryResult = Apollo.QueryResult<
  GetCountriesAndCurrenciesQuery,
  GetCountriesAndCurrenciesQueryVariables
>;
export const GetOfferingCountryCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetOfferingCountryCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offeringId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publishedOfferings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'offeringId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'instruments' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetOfferingCountryCodeQuery__
 *
 * To run a query within a React component, call `useGetOfferingCountryCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferingCountryCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferingCountryCodeQuery({
 *   variables: {
 *      offeringId: // value for 'offeringId'
 *   },
 * });
 */
export function useGetOfferingCountryCodeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOfferingCountryCodeQuery,
    GetOfferingCountryCodeQueryVariables
  > &
    ({ variables: GetOfferingCountryCodeQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOfferingCountryCodeQuery, GetOfferingCountryCodeQueryVariables>(
    GetOfferingCountryCodeDocument,
    options
  );
}
export function useGetOfferingCountryCodeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOfferingCountryCodeQuery,
    GetOfferingCountryCodeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOfferingCountryCodeQuery, GetOfferingCountryCodeQueryVariables>(
    GetOfferingCountryCodeDocument,
    options
  );
}
// @ts-ignore
export function useGetOfferingCountryCodeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetOfferingCountryCodeQuery,
    GetOfferingCountryCodeQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetOfferingCountryCodeQuery, GetOfferingCountryCodeQueryVariables>;
export function useGetOfferingCountryCodeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetOfferingCountryCodeQuery,
        GetOfferingCountryCodeQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetOfferingCountryCodeQuery | undefined,
  GetOfferingCountryCodeQueryVariables
>;
export function useGetOfferingCountryCodeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetOfferingCountryCodeQuery,
        GetOfferingCountryCodeQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetOfferingCountryCodeQuery, GetOfferingCountryCodeQueryVariables>(
    GetOfferingCountryCodeDocument,
    options
  );
}
export type GetOfferingCountryCodeQueryHookResult = ReturnType<
  typeof useGetOfferingCountryCodeQuery
>;
export type GetOfferingCountryCodeLazyQueryHookResult = ReturnType<
  typeof useGetOfferingCountryCodeLazyQuery
>;
export type GetOfferingCountryCodeSuspenseQueryHookResult = ReturnType<
  typeof useGetOfferingCountryCodeSuspenseQuery
>;
export type GetOfferingCountryCodeQueryResult = Apollo.QueryResult<
  GetOfferingCountryCodeQuery,
  GetOfferingCountryCodeQueryVariables
>;
export const IsInternalOfferingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IsInternalOffering' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offeringId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publishedOfferings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'offeringId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'IsInternalOffering_OfferingFullParts' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IsInternalOffering_ManagerFullParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ManagerFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IsInternalOffering_OfferingFullParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OfferingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isInternal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isAuthor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'syndicate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'managers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'IsInternalOffering_ManagerFullParts' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useIsInternalOfferingQuery__
 *
 * To run a query within a React component, call `useIsInternalOfferingQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsInternalOfferingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsInternalOfferingQuery({
 *   variables: {
 *      offeringId: // value for 'offeringId'
 *   },
 * });
 */
export function useIsInternalOfferingQuery(
  baseOptions: Apollo.QueryHookOptions<IsInternalOfferingQuery, IsInternalOfferingQueryVariables> &
    ({ variables: IsInternalOfferingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IsInternalOfferingQuery, IsInternalOfferingQueryVariables>(
    IsInternalOfferingDocument,
    options
  );
}
export function useIsInternalOfferingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IsInternalOfferingQuery,
    IsInternalOfferingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IsInternalOfferingQuery, IsInternalOfferingQueryVariables>(
    IsInternalOfferingDocument,
    options
  );
}
// @ts-ignore
export function useIsInternalOfferingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IsInternalOfferingQuery,
    IsInternalOfferingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IsInternalOfferingQuery, IsInternalOfferingQueryVariables>;
export function useIsInternalOfferingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IsInternalOfferingQuery, IsInternalOfferingQueryVariables>
): Apollo.UseSuspenseQueryResult<
  IsInternalOfferingQuery | undefined,
  IsInternalOfferingQueryVariables
>;
export function useIsInternalOfferingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IsInternalOfferingQuery, IsInternalOfferingQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IsInternalOfferingQuery, IsInternalOfferingQueryVariables>(
    IsInternalOfferingDocument,
    options
  );
}
export type IsInternalOfferingQueryHookResult = ReturnType<typeof useIsInternalOfferingQuery>;
export type IsInternalOfferingLazyQueryHookResult = ReturnType<
  typeof useIsInternalOfferingLazyQuery
>;
export type IsInternalOfferingSuspenseQueryHookResult = ReturnType<
  typeof useIsInternalOfferingSuspenseQuery
>;
export type IsInternalOfferingQueryResult = Apollo.QueryResult<
  IsInternalOfferingQuery,
  IsInternalOfferingQueryVariables
>;
export const IsOfferingAuthor_OfferingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IsOfferingAuthor_Offering' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offeringId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'privateOfferings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'offeringId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAuthor' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publishedOfferings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'offeringId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAuthor' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useIsOfferingAuthor_OfferingQuery__
 *
 * To run a query within a React component, call `useIsOfferingAuthor_OfferingQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsOfferingAuthor_OfferingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsOfferingAuthor_OfferingQuery({
 *   variables: {
 *      offeringId: // value for 'offeringId'
 *   },
 * });
 */
export function useIsOfferingAuthor_OfferingQuery(
  baseOptions: Apollo.QueryHookOptions<
    IsOfferingAuthor_OfferingQuery,
    IsOfferingAuthor_OfferingQueryVariables
  > &
    ({ variables: IsOfferingAuthor_OfferingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IsOfferingAuthor_OfferingQuery, IsOfferingAuthor_OfferingQueryVariables>(
    IsOfferingAuthor_OfferingDocument,
    options
  );
}
export function useIsOfferingAuthor_OfferingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IsOfferingAuthor_OfferingQuery,
    IsOfferingAuthor_OfferingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    IsOfferingAuthor_OfferingQuery,
    IsOfferingAuthor_OfferingQueryVariables
  >(IsOfferingAuthor_OfferingDocument, options);
}
// @ts-ignore
export function useIsOfferingAuthor_OfferingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IsOfferingAuthor_OfferingQuery,
    IsOfferingAuthor_OfferingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IsOfferingAuthor_OfferingQuery,
  IsOfferingAuthor_OfferingQueryVariables
>;
export function useIsOfferingAuthor_OfferingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IsOfferingAuthor_OfferingQuery,
        IsOfferingAuthor_OfferingQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IsOfferingAuthor_OfferingQuery | undefined,
  IsOfferingAuthor_OfferingQueryVariables
>;
export function useIsOfferingAuthor_OfferingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IsOfferingAuthor_OfferingQuery,
        IsOfferingAuthor_OfferingQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    IsOfferingAuthor_OfferingQuery,
    IsOfferingAuthor_OfferingQueryVariables
  >(IsOfferingAuthor_OfferingDocument, options);
}
export type IsOfferingAuthor_OfferingQueryHookResult = ReturnType<
  typeof useIsOfferingAuthor_OfferingQuery
>;
export type IsOfferingAuthor_OfferingLazyQueryHookResult = ReturnType<
  typeof useIsOfferingAuthor_OfferingLazyQuery
>;
export type IsOfferingAuthor_OfferingSuspenseQueryHookResult = ReturnType<
  typeof useIsOfferingAuthor_OfferingSuspenseQuery
>;
export type IsOfferingAuthor_OfferingQueryResult = Apollo.QueryResult<
  IsOfferingAuthor_OfferingQuery,
  IsOfferingAuthor_OfferingQueryVariables
>;

import { makeMockResponse } from '../../../../graphql/mock-response';

export const makeGetCountriesAndCurrenciesMockResponse = makeMockResponse<
  GetCountriesAndCurrenciesQueryVariables,
  GetCountriesAndCurrenciesQuery
>(GetCountriesAndCurrenciesDocument);

export const makeGetOfferingCountryCodeMockResponse = makeMockResponse<
  GetOfferingCountryCodeQueryVariables,
  GetOfferingCountryCodeQuery
>(GetOfferingCountryCodeDocument);

export const makeIsInternalOfferingMockResponse = makeMockResponse<
  IsInternalOfferingQueryVariables,
  IsInternalOfferingQuery
>(IsInternalOfferingDocument);

export const makeIsOfferingAuthor_OfferingMockResponse = makeMockResponse<
  IsOfferingAuthor_OfferingQueryVariables,
  IsOfferingAuthor_OfferingQuery
>(IsOfferingAuthor_OfferingDocument);
